﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("DisclaimersService", [
    "$rootScope",
    function ($rootScope) {
      var disclaimerStore = {};
      var disclaimerGroups = {};

      function DisclaimerGroup(groupName, disclaimerKeys) {
        this.name = groupName;
        this.visible = false;
        this.disclaimerKeys = disclaimerKeys;

        this.addDisclaimerKeys = function (keysToAdd) {
          this.disclaimerKeys = this.disclaimerKeys.concat(keysToAdd);
        };

        this.removeDisclaimerKeys = function (keysToRemove) {
          this.disclaimerKeys = this.disclaimerKeys.filter(function (disclaimerKey) {
            return keysToRemove.indexOf(disclaimerKey) === -1;
          });
        };
      }

      // DisclaimersService requires the Sitecore schema (title, description)
      function ensureSchema(disclaimers, schema) {
        /* eslint-disable no-param-reassign */
        if (disclaimers === null) {
          disclaimers = [];
        }
        /* eslint-enable no-param-reassign */

        return disclaimers.map(function (disclaimer) {
          if (schema === "mdm") {
            return {
              referenceId: disclaimer.title || disclaimer.referenceId,
              disclaimer: disclaimer.description || disclaimer.disclaimer,
            };
          }

          if (schema === "sitecore") {
            return {
              title: disclaimer.title || disclaimer.referenceId,
              description: disclaimer.description || disclaimer.disclaimer,
            };
          }

          throw new Error('Must specify "mdm" or "sitecore" schema.');
        });
      }

      function ingestDisclaimersArray(disclaimers) {
        // eslint-disable-next-line no-param-reassign
        disclaimers = ensureSchema(disclaimers, "sitecore");

        var disclaimersObject = disclaimers.reduce(function (obj, element) {
          obj[element.title] = element.description;
          return obj;
        }, {});
        ingestDisclaimers(disclaimersObject);
      }

      function ingestDisclaimers(disclaimers) {
        angular.extend(disclaimerStore, disclaimers);
      }

      function ingestDisclaimersArrayToGroup(disclaimers, group) {
        ingestDisclaimersArray(disclaimers);

        var disclaimersWithSchema = ensureSchema(disclaimers, "sitecore");
        var disclaimerKeys = disclaimersWithSchema.map(function (el) {
          return el.title;
        });

        addToGroup(group, disclaimerKeys);
        triggerChange();
      }

      function ensureGroupExists(groupName) {
        if (!disclaimerGroups[groupName]) {
          disclaimerGroups[groupName] = new DisclaimerGroup(groupName, []);
        }
      }

      function addToGroup(groupName, disclaimerKeyOrKeys) {
        /* eslint-disable no-param-reassign */
        if (!(disclaimerKeyOrKeys instanceof Array)) {
          disclaimerKeyOrKeys = [disclaimerKeyOrKeys];
        }
        /* eslint-enable no-param-reassign */

        ensureGroupExists(groupName);
        disclaimerGroups[groupName].addDisclaimerKeys(disclaimerKeyOrKeys);
        triggerChange();
      }

      function removeFromGroup(groupName, disclaimerKeyOrKeys) {
        /* eslint-disable no-param-reassign */
        if (!(disclaimerKeyOrKeys instanceof Array)) {
          disclaimerKeyOrKeys = [disclaimerKeyOrKeys];
        }
        /* eslint-enable no-param-reassign */

        ensureGroupExists(groupName);
        disclaimerGroups[groupName].removeDisclaimerKeys(disclaimerKeyOrKeys);
        triggerChange();
      }

      function getGroups() {
        return angular.copy(disclaimerGroups);
      }

      function getGroup(groupName) {
        return angular.copy(disclaimerGroups[groupName]);
      }

      function isDisclaimerInGroup(disclaimerKey, groupName) {
        return (
          disclaimerGroups[groupName] &&
          disclaimerGroups[groupName].disclaimerKeys.findIndex(function (key) {
            return key === disclaimerKey;
          }) !== -1
        );
      }

      function showGroup(groupName) {
        ensureGroupExists(groupName);
        disclaimerGroups[groupName].visible = true;
        triggerChange();
      }

      function purgeGroup(groupName) {
        ensureGroupExists(groupName);

        angular.forEach(disclaimerGroups[groupName].disclaimerKeys, function (disclaimerKey) {
          delete disclaimerStore[disclaimerKey];
        });

        disclaimerGroups[groupName].disclaimerKeys = [];
        triggerChange();
      }

      function hideGroup(groupName) {
        ensureGroupExists(groupName);
        disclaimerGroups[groupName].visible = false;
        triggerChange();
      }

      function getVisibleDisclaimersAsSitecoreArray() {
        var disclaimerStoreAsArray = Object.keys(disclaimerStore)
          .sort()
          .map(function (key) {
            return { title: key, description: disclaimerStore[key] };
          });

        /*
         * Iterate over the disclaimers and for each, iterate over each of the groups.
         * If the key is found in the group, check to see if the group is visible.
         * If at least one group is visible, the disclaimer is visible.
         */

        return disclaimerStoreAsArray.filter(function (disclaimer) {
          var isVisible = false;

          for (var groupName in disclaimerGroups) {
            if (disclaimerGroups[groupName].disclaimerKeys.indexOf(disclaimer.title) !== -1) {
              isVisible = isVisible || disclaimerGroups[groupName].visible;
              if (isVisible) {
                break;
              } // If it's visible then we're done looking.
            }
          }

          return isVisible;
        });
      }

      function triggerChange() {
        $rootScope.$broadcast("disclaimers-updated", getVisibleDisclaimersAsSitecoreArray());
      }

      function getAllDisclaimers() {
        return angular.copy(disclaimerStore);
      }

      return {
        ensureSchema: ensureSchema,
        ingestDisclaimers: ingestDisclaimers,
        ingestDisclaimersArray: ingestDisclaimersArray,
        ingestDisclaimersArrayToGroup: ingestDisclaimersArrayToGroup,
        addToGroup: addToGroup,
        removeFromGroup: removeFromGroup,
        showGroup: showGroup,
        hideGroup: hideGroup,
        getAllDisclaimers: getAllDisclaimers,
        getVisibleDisclaimersAsSitecoreArray: getVisibleDisclaimersAsSitecoreArray,
        getGroup: getGroup,
        getGroups: getGroups,
        purgeGroup: purgeGroup,
        isDisclaimerInGroup: isDisclaimerInGroup,
      };
    },
  ]);
})(window.angular);
